const CheckDailyLimit = {
  CHECK_DAILY_LIMIT: 'CHECK_DAILY_LIMIT',
};

export default CheckDailyLimit;
